// @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/enum/lineup-type.json
const LineupType = {
    Home: { key: 'home', name: 'Home' },
    Away: { key: 'away', name: 'Away' },
    Practice: { key: 'practice', name: 'Practice' },
};

export default LineupType;